export default __webpack_public_path__ + "static/media/27.86a0f399.png";